import { idRef, newMeasure } from '@gooddata/sdk-model';
import { useExecutionDataView } from '@gooddata/sdk-ui';
import { useRef } from 'react';
import { Metrics } from './generated/internal';

const updatedOnMeasure = newMeasure(idRef(Metrics.maximumTimeSinceDataUpdatedPerProperty, 'measure'));

export const useUpdatedOn = () => {
    const { result, status } = useExecutionDataView({
        execution: {
            seriesBy: [updatedOnMeasure],
        },
    });

    const updatedOn = result ? Number(result.dataView.data[0]) : null;

    return {
        isLoading: status === 'loading',
        updatedOn,
    };
};

export const useMeasurePerformance = () => {
    const startLoadTime = useRef(0);
    const endLoadTime = useRef(0);

    const startTracking = () => {
        startLoadTime.current = performance.now();
    };

    const endTracking = () => {
        endLoadTime.current = performance.now();
    };

    const getTimeToLoad = () => Math.ceil(endLoadTime.current - startLoadTime.current);

    return {
        startTracking,
        endTracking,
        getTimeToLoad,
    };
};
